import { CountdownPosition, TextAlignment, TimerType } from '@/types';

export const COUNTDOWN_POSITION_CLASS: Record<CountdownPosition, string> = {
	[CountdownPosition.RIGHT_OF_TITLE]: 'countdown-position-right',
	[CountdownPosition.LEFT_OF_TITLE]: 'countdown-position-left',
	[CountdownPosition.ABOVE_TITLE]: 'countdown-position-above',
	[CountdownPosition.BELOW_TITLE]: 'countdown-position-below',
};

export function getDefaultCountdownPosition(timerType: TimerType): CountdownPosition {
	return timerType === TimerType.PRODUCT_CONTAINER ? CountdownPosition.BELOW_TITLE : CountdownPosition.RIGHT_OF_TITLE;
}

export function getCountdownPositionClass(position?: CountdownPosition): string {
	return (
		COUNTDOWN_POSITION_CLASS[position ?? CountdownPosition.RIGHT_OF_TITLE] ??
		COUNTDOWN_POSITION_CLASS[CountdownPosition.RIGHT_OF_TITLE]
	);
}

export const COUNTER_ALIGNMENT: Record<TextAlignment, string> = {
	[TextAlignment.LEFT]: 'flex-start',
	[TextAlignment.CENTER]: 'center',
	[TextAlignment.RIGHT]: 'flex-end',
};

const TEXT_ALIGNED_BUTTON_POSITIONS: CountdownPosition[] = [
	CountdownPosition.ABOVE_TITLE,
	CountdownPosition.BELOW_TITLE,
];

export function resolveButtonAlignment(position: CountdownPosition | undefined, textAlignment: TextAlignment): string {
	if (!position || !TEXT_ALIGNED_BUTTON_POSITIONS.includes(position)) {
		return COUNTER_ALIGNMENT[TextAlignment.CENTER];
	}

	return COUNTER_ALIGNMENT[textAlignment] ?? COUNTER_ALIGNMENT[TextAlignment.LEFT];
}
